export const templateKeys = {
  listAll: ['TEMPLATES'] as const,
  list: (organization: unknown, documentSuperId: number | string | undefined, type?: string, selected?: boolean) => [
    'TEMPLATES',
    organization,
    documentSuperId,
    type,
    selected,
  ],
  forDocument: (documentSuperId: number | string) => ['TEMPLATES', documentSuperId],
  docWithStyle: (documentSuperId: number | string, templateId: string) => ['TEMPLATES', 'doc-with-style', documentSuperId, templateId],
  detailAll: ['TEMPLATE'] as const,
  detail: (revisionId: string) => ['TEMPLATE', revisionId],
  compiled: (superId: string, organization: unknown, documentSuperId?: number | string) => ['TEMPLATE', superId, organization, documentSuperId, 'compiled'],
  selectedAll: ['TEMPLATES_SELECTED'] as const,
  selected: (documentSuperId: number | string) => ['TEMPLATES_SELECTED', documentSuperId],
};
